// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__fBVO3","subheader":"ReorderModal_subheader__2iwoa","listWrap":"ReorderModal_listWrap__1ku82"};